<template>
  <div style="background: linear-gradient(to bottom, #f0f8ff, #e6f7ff);">
    <Header />
<!--    <mall-header @search="search" :showSearch="true" />-->
    <div id="mall-index" style="background-color: #f9f7f7;">
<!--      <div class="header">-->
<!--        <img :src="getFileUrl('/jifen/banner.png')">-->
<!--      </div>-->
<!--      <div class="header">-->
<!--        <a-carousel autoplay>-->
<!--          <div style="max-height: 477.94px" v-for="(it, index) in slideshow" :key="index">-->
<!--            <img class="header_img" :src="getFileUrl(it.imageUrl || '')" style="max-height: 477.94px" />-->
<!--          </div>-->
<!--        </a-carousel>-->
<!--      </div>-->
      <!-- 轮播图 -->
      <div class="slider-container">
        <div class="slider" :style="{ 'transform': `translateX(-${carouselIndex * 100}%)` }">
          <div
              class="slide"
              :style="{ 'background': 'url('+ getFileUrl(it.imageUrl || '') +')', 'background-repeat': 'no-repeat' ,'background-size': 'cover', 'background-position': 'center' }"
              style=""
              v-for="(it, index) in slideshow" :key="index"
          >
<!--            <div class="slide-content">-->
<!--              <h2>夏日狂欢季</h2>-->
<!--              <p>超值积分兑换，千款好物低至5折，企业会员专享优惠</p>-->
<!--            </div>-->
          </div>
<!--          <div class="slide" style="background: linear-gradient(135deg, #a1c4fd, #c2e9fb);">-->
<!--            <div class="slide-content">-->
<!--              <h2>企业专享福利</h2>-->
<!--              <p>新企业注册即送2000积分，兑换办公用品享额外折扣</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="slide" style="background: linear-gradient(135deg, #ffecd2, #fcb69f);">-->
<!--            <div class="slide-content">-->
<!--              <h2>积分翻倍活动</h2>-->
<!--              <p>活动期间，所有商品兑换积分双倍返还，限时特惠</p>-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <button class="slider-btn prev-btn" @click="flipOver(0, 'up')"><i><img src="@/assets/icon/left.png" /></i></button>
        <button class="slider-btn next-btn" @click="flipOver(0, 'next')"><i><img src="@/assets/icon/right.png" /></i></button>
        <div class="slider-indicators" >
          <div
              v-for="(it, index) in slideshow" :key="index"
              :class=" index === carouselIndex ? 'indicator active' : 'indicator' "
              @click="flipOver(index, '')"
          >
          </div>
        </div>
      </div>
      <div class="clearfix">
        <div class="fruit_list">
          <company-module :goodsList="goodsList" :total="total" @paginationChange="paginationChange"/>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import MallHeader from './modules/Header'
import {loadCompany, slideshowList} from "@/api/mall";
import fileUrlMixin from "@/mixins/fileUrlMixin";
import CompanyModule from "@/views/mall/modules/CompanyModule.vue";
import {advertisingReport} from "@/api/account";

export default {
  components: {
    CompanyModule,
    Header,
    Footer,
    MallHeader
  },
  mixins: [fileUrlMixin],
  data () {
    return {
      intervalId: null,  // 定时器ID
      carouselIndex: 0,
      slideshow: [],
      goodsList: [],
      total: 0,
      current: 1,
      params: {
        size: 8,
        pageSize: 8,
        // size: 10,
        current: 1,
        name: ''
      }
    }
  },
  mounted() {
    this.params.name = this.$route.query.name
    this.getGoods() // 差供应商
    this.getslideshowList()
    // this.getSupplier()
    this.startAutoPlay();
    // if (this.$route.query?.clickId) {
    //   this.uploadMethod()
    // }
  },
  beforeDestroy() {
    // 离开页面时销毁定时器
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    uploadMethod () {
      // 广告上报
      advertisingReport([{
        deviceId: '',
        sessionId: '',
        clickId: this.$route.query.clickId,
        eventType: 'page_view', // 什么事件
        adId: this.$route.query.adId,
        eventTime: Date.now(),
        url: '/index', // 跳转后的页面地址
        position: '积分商城首页',
        adType: this.$route.query.adType
      }])
    },
    // 启动定时器
    startAutoPlay() {
      this.intervalId = setInterval(() => {
        this.flipOver(0, 'next');
      }, 5000);  // 每5秒自动切换一次
    },
    flipOver(i, t){
      if(t === 'next'){
        this.carouselIndex = (this.carouselIndex + 1) % this.slideshow.length;
      }
      if(t === 'up' && this.carouselIndex !== 0){
        this.carouselIndex = (this.carouselIndex - 1) % this.slideshow.length;
      }
      if(t === ''){
        this.carouselIndex = (i) % this.slideshow.length;
      }
    },
    getslideshowList () {
      slideshowList({ type: 1 }).then(res =>{
        this.slideshow = res.data
      })
    },
    getGoods () {
      loadCompany({ query: { ...this.params },  ...this.params}).then(res =>{
        this.goodsList  = res.data.records.map(it => ({
          ...it,
          supplierCompanyContacts: it.supplierCompanyContacts?.split(','),
          supplierCompanyPhone: it.supplierCompanyPhone?.split(',')
        }))
        this.total  = res.data.total
      })
    },
    search (key) {
      this.params.companyName = key
      this.getGoods()
    },
    paginationChange (key) {
      this.params.current = key
      this.getGoods()
    },
    // getSupplier () {
    //   supplierInfo().then(res => {
    //     this.supplierList = res.data
    //   })
    // }
  }
}
</script>

<style lang="less" scoped>
#mall-index {
  width: 1200px;
  margin: 0 auto;
  background: linear-gradient(to bottom, #f0f8ff, #e6f7ff);
}
.header{
  width: 100%;
  height: 480px;
  margin: 20px 0;
}
.header_img{
  width: 100%;
  height: 100%;
  object-fit: cover
}
.clearfix {
  display: flex;
}
.supplier-card {
  width: 15%;
  margin-right: 10px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  .card-title{
    background-color: #f3f3f3;
    text-align: center;
    height: 40px;
    line-height: 40px;
    font-weight: 600;
  }
  .card-content {
    min-height: 650px;
    padding: 0 5px;
  }
  .item-card{
    padding: 10px;
    border-bottom: 1px dashed #e6e6e6;
    font-weight: 550;
    p{
      font-size: 13px;
    }
    .supplierName{
      font-size: 15px;
    }
    .contactNumber {
      word-break: break-all;
    }
    &:last-child{
      border: none;
    }
  }
}
.fruit_list{
  flex: 1;
}

/* 轮播图样式 */
.slider-container {
  max-width: 1200px;
  margin: 30px auto;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  height: 400px;
  position: relative;
}

.slider {
  height: 100%;
  display: flex;
  transition: transform 0.5s ease-in-out;
}

.slide {
  min-width: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
}

.slide-content {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.85);
  color: #2c3e50;
  padding: 30px;
  backdrop-filter: blur(5px);
}

.slide-content h2 {
  font-size: 32px;
  margin-bottom: 10px;
  color: #2c3e50;
}

.slide-content p {
  font-size: 18px;
  max-width: 600px;
  color: #34495e;
}

.slider-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.7);
  color: #2c3e50;
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}

.slider-btn:hover {
  background: rgba(255, 255, 255, 0.9);
  transform: translateY(-50%) scale(1.1);
}

.prev-btn {
  left: 20px;
}

.next-btn {
  right: 20px;
}

.slider-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
}

.indicator {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid rgba(255, 255, 255, 0.8);
}

.indicator.active {
  background-color: #fff;
  transform: scale(1.2);
  border-color: #a1c4fd;
}

</style>
